import React, { useEffect, useState } from 'react';
import './App.scss';
import Platform from './Platform';
import AnnonymousRoutes from './Routes/AnonnymousRoutes';
import Loading from './Shared/Loading';
import TSAFavicon from './Assets/tsa-favicon.ico';
import { isAuthReady, useAuthState } from './Services/AuthService';

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const auth = useAuthState();
  const isLocalEnvironment = window.location.hostname === 'localhost';
  const isTestEnvironment = isLocalEnvironment || window.location.hostname.includes('test');

  const isAnonymousPublicPath = () => {
    const path = window.location.pathname.toLowerCase();

    return path.includes('/reset/')
      || path.includes('/confirm/')
      || path.includes('/register/')
      || path.includes('/gdpr/privacy')
      || path.includes('/certificate/')
      || path.includes('/verify/');
  };

  const redirectToLogin = () => {
    if (window.location.pathname !== '/') {
      window.location.replace('/');
    }
  };

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    link.href = TSAFavicon;
    document.title = "TheSustainabilityAcademy | eLearning";

    if (!isAuthReady()) {
      return;
    }

    setIsLoading(false);
  }, [auth.isLoading]);

  useEffect(() => {
    if (!isLoading && !auth.isLoading && !auth.isAuthenticated && !isAnonymousPublicPath()) {
      redirectToLogin();
    }
  }, [auth.isAuthenticated, auth.isLoading, isLoading]);

  return (
    <div className={isTestEnvironment ? 'app-shell has-environment-banner' : 'app-shell'}>
      {isTestEnvironment && (
        <div className="environment-banner">
          {isLocalEnvironment ? 'Local environment: changes here do not affect test or production.' : 'Test environment: changes here do not affect production.'}
        </div>
      )}
      {
        isLoading ?
          <Loading />
          :
          <>
            {(isAnonymousPublicPath() || !auth.isAuthenticated) ?
              <AnnonymousRoutes />
              :
              <Platform />
            }
          </>
      }
    </div>
  );
};

export default App;